// extracted by mini-css-extract-plugin
export var avatarContainer = "_bj-0";
export var avatarTypingWave = "_bj-i";
export var gray = "_bj-f";
export var green = "_bj-c";
export var icon = "_bj-9";
export var image = "_bj-1";
export var lg = "_bj-6";
export var md = "_bj-5";
export var presenceDot = "_bj-b";
export var red = "_bj-d";
export var sm = "_bj-4";
export var status = "_bj-a";
export var typingDot = "_bj-h";
export var typingPill = "_bj-g";
export var xl = "_bj-7";
export var xs = "_bj-3";
export var xxl = "_bj-8";
export var xxs = "_bj-2";
export var yellow = "_bj-e";